// Thème MUI léger pour les 2 pages publiques d'accréditation (config externe + formulaire),
// qui vivent hors de App.js et n'héritent donc jamais des styles Wilout habituels
// (@wilout/ui-css n'est importé que dans App.js, jamais dans index.js pour cet arbre séparé —
// voir PublicAccreditationApp.js). Couleurs reprises en dur du design system
// (node_modules/@wilout/ui-css/dist/ui.css, palette claire) puisque ses variables CSS
// --ui-color-* ne sont pas définies ici.
import { createTheme } from '@mui/material/styles';

export const accreditationTheme = createTheme({
  palette: {
    primary: { main: '#00be9e', dark: '#002f36', light: '#00e0af', contrastText: '#ffffff' },
    success: { main: '#2fbb5d' },
    error: { main: '#e83a43' },
    text: { primary: '#002f36', secondary: '#5b6b70' },
    background: { default: '#f4f7f9', paper: '#ffffff' },
    divider: '#dde3e8',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});

export default accreditationTheme;
